'use client';

import { createContext, useContext, type ReactNode } from 'react';

type InternalNetworkGraphNodeActionsContextValue = {
  selectedNodeId: string | null;
  isExpanding: boolean;
  onExpand: (nodeId: string) => void;
  onViewDetails: (nodeId: string) => void;
  onCloseSelection: () => void;
};

const InternalNetworkGraphNodeActionsContext =
  createContext<InternalNetworkGraphNodeActionsContextValue | null>(null);

export function InternalNetworkGraphNodeActionsProvider({
  value,
  children,
}: {
  value: InternalNetworkGraphNodeActionsContextValue;
  children: ReactNode;
}) {
  return (
    <InternalNetworkGraphNodeActionsContext.Provider value={value}>
      {children}
    </InternalNetworkGraphNodeActionsContext.Provider>
  );
}

export function useInternalNetworkGraphNodeActions() {
  return useContext(InternalNetworkGraphNodeActionsContext);
}
